import React from 'react';
import {DmsTab, RegionCascader} from 'Components';
import {hashHistory} from 'react-router';
import {Form, Input, Select, Button, Row, Col,message} from 'antd';
import {regionDetail, regionAdd, regionModify} from '../../service/region';
const Option = Select.Option;
const FormItem = Form.Item;
const {TextArea} = Input;
import {nameValidator,checkCode} from '../../utils/regexp.js';
import {showSpin,hideSpin} from 'Utils';

class Regionadd extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['新建地区'],
			detail: {},
			tree: []
		};
		this.checkSortOrder=this.checkSortOrder.bind(this);
	}
	
	componentDidMount() {
		if (this.props.location.query.regionId) {
			this.setState({
				opts: ['编辑地区']
			})
			//根据传过来的index，获取特定的值，并赋值给detail
			var regionObj = {};
			regionObj.id = parseInt(this.props.location.query.regionId, 0);
			regionDetail(regionObj).then(result => {
				if (result.status) {
					var pathArr = result.data.fullPath.split(',');
					var pathStr = pathArr.slice(0, pathArr.length - 1).join(';');
					result.data.parentPath = pathStr;
					this.setState({
						detail: result.data
					})
				} else {
					message.error(result.message);
				}
			})
		}
	}
	
	
	cancelHandle() {
		hashHistory.goBack();
	}
	
	submitHandle() {
		const {validateFields, getFieldsValue} = this.props.form;
		
		validateFields((errors) => {//表单校验
			if (errors) {
				return
			}//表单校验有误，则不执行下面的代码
			var data = {
				...getFieldsValue() //获取用户输入
			};
			if (data.active === '1') {
				data.active = 1;
			} else {
				data.active = 0;
			}
			if (data.parentId != null && data.parentId.selectedOptions.length > 0) {
				var regionNum = data.parentId.selectedOptions[data.parentId.selectedOptions.length - 1].regionId;
				data.parentRegionId = parseInt(regionNum, 0);
			} else {
				data.parentRegionId = this.state.detail.parentRegionId;
			}
      showSpin();
			if (this.props.location.query.regionId) {
				data.regionId = this.state.detail.regionId;
				regionModify(data).then(result => {
					hideSpin();
					if (result.status) {
						message.success(result.message);
						hashHistory.goBack();
					} else {
						message.error(result.message);
					}
				})
			} else {
				regionAdd(data).then(result => {
					hideSpin();
					if (result.status) {
						message.success(result.message);
						hashHistory.goBack();
					} else {
						message.error(result.message);
					}
				})
			}
		})
	}
	
	//排序正则
	checkSortOrder(rule, value, callback) {
		const vaReg = /^\d{1,}$/;
		if (value) {
			if (!(vaReg.test(value))) {
				callback('排序只可输入整数');
			}
			callback();
		}
		callback();
	}
	
	render() {
		const {opts, detail} = this.state;
		const {getFieldDecorator} = this.props.form;
		return <div className='dms-body'>
			<DmsTab options={opts} defaultKey={0}>
				<Button onClick={this.cancelHandle.bind(this)}>取消</Button>
				<Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
			</DmsTab>
			<div className="dms-table-box" style={{backgroundColor: "#fff"}}>
				<Form layout="horizontal">
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="地区名称" hasFeedback>
								{getFieldDecorator('regionName', {
									initialValue: (detail !== null && detail.regionName) ? detail.regionName : '',
									rules: [
										{
											required: true,
											message: '请输入地区名称'
										},
										{
											validator: nameValidator
										}
									],
								})(<Input placeholder="请输入地区名称"/>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="地区编码" hasFeedback>
								{getFieldDecorator('regionCode', {
									initialValue: (detail !== null && detail.regionCode) ? detail.regionCode : '',
									rules: [
										{
											required: true,
											message: '请输入地区编码'
										},
										{
											validator: checkCode
										}
									]
								})(<Input placeholder="请输入地区编码"/>)}
							</FormItem>
						</Col>
					</Row>
					
					{detail&&detail.regionId&&<Row>
						<p style={{marginBottom:'20px'}}>当前上级地区: {detail.parentPath}</p>
					</Row>}
					<Row>
						<FormItem label="上级地区" hasFeedback>
              {getFieldDecorator('parentId',
                {
                  rules: [
                    {
                      required: detail !== null && detail.regionId ? false : true,
                      message: '请选择上级地区'
                    },
                  ]
                })(<RegionCascader placeholder="请选择上级地区" style={{width: '100%'}}/>)}
						</FormItem>
					</Row>
					<Row>
						<FormItem label="描述">
							{getFieldDecorator('description', {
								initialValue: (detail !== null && detail.description) ? detail.description : ''
							})(<TextArea rows={4}/>)}
						</FormItem>
					</Row>
					
					<Row gutter={16}>
						<Col className="gutter-row" span={12}>
							<FormItem label="有效性">
								{getFieldDecorator('active', {
									initialValue: (detail !== null && detail.active === 0) ? '0' : "1",
									rules: [
										{
											required: true,
											message: '请选择是否有效'
										},
									]
								})(<Select>
									<Option value='1'>有效</Option>
									<Option value='0'>无效</Option>
								</Select>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="排序">
								{getFieldDecorator('sortOrder', {
									initialValue: (detail !== null && detail.sortOrder) ? detail.sortOrder : '',
									rules: [
										{
											validator: this.checkSortOrder
										}
									]
								})(<Input />)}
							</FormItem>
						</Col>
					</Row>
				
				</Form>
			</div>
		</div>
	}
}
export default Form.create()(Regionadd)


// WEBPACK FOOTER //
// ./src/routes/region/add.js